/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-26 13:48:39 */

const Keys = { bookings: 'bookings', profile: 'profile', logout: 'logout' }; export default Keys;